import Layout from 'components/layouts/main'
import Head from 'next/head'

export default function Faqs() {
  return (
    <>
      <Head>
        <title key="title">TotalSystemCare | FAQs</title>
      </Head>
      <Layout>
        <section className="hero-section">
          <div className="container policy-container">
            <div className="policy-wrapper">
              <div className="policy-title">
                <h1>Frequently Asked Questions</h1>
              </div>
              <p className="text">
                <b>Where can I find my license key?</b>
              </p>
              <p className="text">
                From the TotalSystemCare main screen, click on the ‘License’
                button found on the top menu.
              </p>
              <p className="text">
                <b>How do I confirm if my software is activated?</b>
              </p>
              <p className="text">
                Look at the top left portion of TotalSystemCare and click on the
                “License” tab. A screen will appear showing the license key you
                purchased upon registration.
              </p>
              <p className="text">
                <b>How do I contact support?</b>
              </p>
              <p className="text">
                Product support is available 24/7 via chat and email.
                Please&nbsp;click on the link below to submit your ticket or
                initiate a chat and we’ll reply as soon as possible to your
                inquiry. <br />{' '}
                <a
                  href="http://totalsystemcare.com/product/contact.php"
                  title="Contact us"
                >
                  Click here
                </a>{' '}
                to connect with us. You can also open a support ticket from
                directly within TotalSystemCare:
              </p>
              <p className="text">
                <b>
                  If the software does not meet my expectations, can I uninstall
                  it from my computer?
                </b>
              </p>
              <p className="text">
                Yes, just like any other program installed on your Windows
                machine, TotalSystemCare can be safely uninstalled using
                “Programs and Features” option from your system{' '}
                <a href="/how-to-uninstall" title="Uninstall TotalSystemCare">
                  Control Panel
                </a>
              </p>
              <p className="text">
                <b>
                  What are the supported operating systems for TotalSystemCare?
                </b>
              </p>
              <p className="text">
                Windows XP SP2
                <br />
                Windows Vista
                <br />
                Windows 7<br />
                Windows 8<br />
                Windows 10
              </p>
              <p className="text"> Last Updated on April 18, 2022</p>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}
